/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-wallet/blob/master/LICENSE.md
 */
package org.mifospay.core.data.util

internal val SAMPLE_LOCALE = """
    [
      {
        "countryName": "Afrikaans (South Africa)",
        "localName": "af_ZA",
        "dominantName": "af_ZA"
      },
      {
        "countryName": "Albanian (Albania)",
        "localName": "sq_AL",
        "dominantName": "sq_AL"
      },
      {
        "countryName": "Arabic (Algeria)",
        "localName": "ar_DZ",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Bahrain)",
        "localName": "ar_BH",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Egypt)",
        "localName": "ar_EG",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Iraq)",
        "localName": "ar_IQ",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Jordan)",
        "localName": "ar_JO",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Kuwait)",
        "localName": "ar_KW",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Lebanon)",
        "localName": "ar_LB",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Libya)",
        "localName": "ar_LY",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Morocco)",
        "localName": "ar_MA",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Oman)",
        "localName": "ar_OM",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Qatar)",
        "localName": "ar_QA",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Saudi Arabia)",
        "localName": "ar_SA",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Syria)",
        "localName": "ar_SY",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Tunisia)",
        "localName": "ar_TN",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (United Arab Emirates)",
        "localName": "ar_AE",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Arabic (Yemen)",
        "localName": "ar_YE",
        "dominantName": "ar_SA"
      },
      {
        "countryName": "Armenian (Armenia)",
        "localName": "hy_AM",
        "dominantName": "hy_AM"
      },
      {
        "countryName": "Azerbaijani (Azerbaijan)",
        "localName": "az_AZ",
        "dominantName": "az_AZ"
      },
      {
        "countryName": "Basque (Spain)",
        "localName": "eu_ES",
        "dominantName": "eu_ES"
      },
      {
        "countryName": "Belarusian (Belarus)",
        "localName": "be_BY",
        "dominantName": "be_BY"
      },
      {
        "countryName": "Bengali (India)",
        "localName": "bn_IN",
        "dominantName": "bn_IN"
      },
      {
        "countryName": "Bosnian (Bosnia and Herzegovina)",
        "localName": "bs_BA",
        "dominantName": "bs_BA"
      },
      {
        "countryName": "Bulgarian (Bulgaria)",
        "localName": "bg_BG",
        "dominantName": "bg_BG"
      },
      {
        "countryName": "Catalan (Spain)",
        "localName": "ca_ES",
        "dominantName": "ca_ES"
      },
      {
        "countryName": "Chinese (China)",
        "localName": "zh_CN",
        "dominantName": "zh_CN"
      },
      {
        "countryName": "Chinese (Hong Kong SAR China)",
        "localName": "zh_HK",
        "dominantName": "zh_TW"
      },
      {
        "countryName": "Chinese (Macao SAR China)",
        "localName": "zh_MO",
        "dominantName": "zh_TW"
      },
      {
        "countryName": "Chinese (Singapore)",
        "localName": "zh_SG",
        "dominantName": "zh_CN"
      },
      {
        "countryName": "Chinese (Taiwan)",
        "localName": "zh_TW",
        "dominantName": "zh_TW"
      },
      {
        "countryName": "Croatian (Croatia)",
        "localName": "hr_HR",
        "dominantName": "hr_HR"
      },
      {
        "countryName": "Czech (Czech Republic)",
        "localName": "cs_CZ",
        "dominantName": "cs_CZ"
      },
      {
        "countryName": "Danish (Denmark)",
        "localName": "da_DK",
        "dominantName": "da_DK"
      },
      {
        "countryName": "Dutch (Belgium)",
        "localName": "nl_BE",
        "dominantName": "nl_NL"
      },
      {
        "countryName": "Dutch (Netherlands)",
        "localName": "nl_NL",
        "dominantName": "nl_NL"
      },
      {
        "countryName": "English (Australia)",
        "localName": "en_AU",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (Belize)",
        "localName": "en_BZ",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (Canada)",
        "localName": "en_CA",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (Ireland)",
        "localName": "en_IE",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (Jamaica)",
        "localName": "en_JM",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (New Zealand)",
        "localName": "en_NZ",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (Philippines)",
        "localName": "en_PH",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (South Africa)",
        "localName": "en_ZA",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (Trinidad and Tobago)",
        "localName": "en_TT",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (U.S. Virgin Islands)",
        "localName": "en_VI",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (India)",
        "localName": "en_IN",
        "dominantName": "en_IN"
      },
      {
        "countryName": "English (United Kingdom)",
        "localName": "en_GB",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (United States)",
        "localName": "en_US",
        "dominantName": "en_US"
      },
      {
        "countryName": "English (Zimbabwe)",
        "localName": "en_ZW",
        "dominantName": "en_US"
      },
      {
        "countryName": "Estonian (Estonia)",
        "localName": "et_EE",
        "dominantName": "et_EE"
      },
      {
        "countryName": "Faroese (Faroe Islands)",
        "localName": "fo_FO",
        "dominantName": "fo_FO"
      },
      {
        "countryName": "Finnish (Finland)",
        "localName": "fi_FI",
        "dominantName": "fi_FI"
      },
      {
        "countryName": "French (Belgium)",
        "localName": "fr_BE",
        "dominantName": "fr_FR"
      },
      {
        "countryName": "French (Canada)",
        "localName": "fr_CA",
        "dominantName": "fr_FR"
      },
      {
        "countryName": "French (France)",
        "localName": "fr_FR",
        "dominantName": "fr_FR"
      },
      {
        "countryName": "French (Luxembourg)",
        "localName": "fr_LU",
        "dominantName": "fr_FR"
      },
      {
        "countryName": "French (Monaco)",
        "localName": "fr_MC",
        "dominantName": "fr_FR"
      },
      {
        "countryName": "French (Switzerland)",
        "localName": "fr_CH",
        "dominantName": "fr_FR"
      },
      {
        "countryName": "Galician (Spain)",
        "localName": "gl_ES",
        "dominantName": "gl_ES"
      },
      {
        "countryName": "Georgian (Georgia)",
        "localName": "ka_GE",
        "dominantName": "ka_GE"
      },
      {
        "countryName": "German (Austria)",
        "localName": "de_AT",
        "dominantName": "de_DE"
      },
      {
        "countryName": "German (Germany)",
        "localName": "de_DE",
        "dominantName": "de_DE"
      },
      {
        "countryName": "German (Liechtenstein)",
        "localName": "de_LI",
        "dominantName": "de_DE"
      },
      {
        "countryName": "German (Luxembourg)",
        "localName": "de_LU",
        "dominantName": "de_DE"
      },
      {
        "countryName": "German (Switzerland)",
        "localName": "de_CH",
        "dominantName": "de_DE"
      },
      {
        "countryName": "Greek (Greece)",
        "localName": "el_GR",
        "dominantName": "el_GR"
      },
      {
        "countryName": "Gujarati (India)",
        "localName": "gu_IN",
        "dominantName": "gu_IN"
      },
      {
        "countryName": "Hebrew (Israel)",
        "localName": "he_IL",
        "dominantName": "he_IL"
      },
      {
        "countryName": "Hindi (India)",
        "localName": "hi_IN",
        "dominantName": "hi_IN"
      },
      {
        "countryName": "Hungarian (Hungary)",
        "localName": "hu_HU",
        "dominantName": "hu_HU"
      },
      {
        "countryName": "Icelandic (Iceland)",
        "localName": "is_IS",
        "dominantName": "is_IS"
      },
      {
        "countryName": "Indonesian (Indonesia)",
        "localName": "id_ID",
        "dominantName": "id_ID"
      },
      {
        "countryName": "Italian (Italy)",
        "localName": "it_IT",
        "dominantName": "it_IT"
      },
      {
        "countryName": "Italian (Switzerland)",
        "localName": "it_CH",
        "dominantName": "it_IT"
      },
      {
        "countryName": "Japanese (Japan)",
        "localName": "ja_JP",
        "dominantName": "ja_JP"
      },
      {
        "countryName": "Kannada (India)",
        "localName": "kn_IN",
        "dominantName": "kn_IN"
      },
      {
        "countryName": "Kazakh (Kazakhstan)",
        "localName": "kk_KZ",
        "dominantName": "kk_KZ"
      },
      {
        "countryName": "Konkani (India)",
        "localName": "kok_IN",
        "dominantName": "kok_IN"
      },
      {
        "countryName": "Korean (South Korea)",
        "localName": "ko_KR",
        "dominantName": "ko_KR"
      },
      {
        "countryName": "Latvian (Latvia)",
        "localName": "lv_LV",
        "dominantName": "lv_LV"
      },
      {
        "countryName": "Lithuanian (Lithuania)",
        "localName": "lt_LT",
        "dominantName": "lt_LT"
      },
      {
        "countryName": "Macedonian (Macedonia)",
        "localName": "mk_MK",
        "dominantName": "mk_MK"
      },
      {
        "countryName": "Malay (Brunei)",
        "localName": "ms_BN",
        "dominantName": "ms_MY"
      },
      {
        "countryName": "Malay (Malaysia)",
        "localName": "ms_MY",
        "dominantName": "ms_MY"
      },
      {
        "countryName": "Malayalam (India)",
        "localName": "ml_IN",
        "dominantName": "ml_IN"
      },
      {
        "countryName": "Maltese (Malta)",
        "localName": "mt_MT",
        "dominantName": "mt_MT"
      },
      {
        "countryName": "Marathi (India)",
        "localName": "mr_IN",
        "dominantName": "mr_IN"
      },
      {
        "countryName": "Mongolian (Mongolia)",
        "localName": "mn_MN",
        "dominantName": "mn_MN"
      },
      {
        "countryName": "Northern Sami (Norway)",
        "localName": "se_NO",
        "dominantName": "se_NO"
      },
      {
        "countryName": "Norwegian Bokmål (Norway)",
        "localName": "nb_NO",
        "dominantName": "nb_NO"
      },
      {
        "countryName": "Norwegian Nynorsk (Norway)",
        "localName": "nn_NO",
        "dominantName": "nn_NO"
      },
      {
        "countryName": "Persian (Iran)",
        "localName": "fa_IR",
        "dominantName": "fa_IR"
      },
      {
        "countryName": "Polish (Poland)",
        "localName": "pl_PL",
        "dominantName": "pl_PL"
      },
      {
        "countryName": "Portuguese (Brazil)",
        "localName": "pt_BR",
        "dominantName": "pt_BR"
      },
      {
        "countryName": "Portuguese (Portugal)",
        "localName": "pt_PT",
        "dominantName": "pt_BR"
      },
      {
        "countryName": "Punjabi (India)",
        "localName": "pa_IN",
        "dominantName": "pa_IN"
      },
      {
        "countryName": "Romanian (Romania)",
        "localName": "ro_RO",
        "dominantName": "ro_RO"
      },
      {
        "countryName": "Russian (Russia)",
        "localName": "ru_RU",
        "dominantName": "ru_RU"
      },
      {
        "countryName": "Serbian (Bosnia and Herzegovina)",
        "localName": "sr_BA",
        "dominantName": "sr_BA"
      },
      {
        "countryName": "Serbian (Serbia And Montenegro)",
        "localName": "sr_CS",
        "dominantName": "sr_BA"
      },
      {
        "countryName": "Slovak (Slovakia)",
        "localName": "sk_SK",
        "dominantName": "sk_SK"
      },
      {
        "countryName": "Slovenian (Slovenia)",
        "localName": "sl_SI",
        "dominantName": "sk_SK"
      },
      {
        "countryName": "Spanish (Argentina)",
        "localName": "es_AR",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Bolivia)",
        "localName": "es_BO",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Chile)",
        "localName": "es_CL",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Colombia)",
        "localName": "es_CO",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Costa Rica)",
        "localName": "es_CR",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Dominican Republic)",
        "localName": "es_DO",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Ecuador)",
        "localName": "es_EC",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (El Salvador)",
        "localName": "es_SV",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Guatemala)",
        "localName": "es_GT",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Honduras)",
        "localName": "es_HN",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Mexico)",
        "localName": "es_MX",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Nicaragua)",
        "localName": "es_NI",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Panama)",
        "localName": "es_PA",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Paraguay)",
        "localName": "es_PY",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Peru)",
        "localName": "es_PE",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Puerto Rico)",
        "localName": "es_PR",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Spain)",
        "localName": "es_ES",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Uruguay)",
        "localName": "es_UY",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Spanish (Venezuela)",
        "localName": "es_VE",
        "dominantName": "es_ES"
      },
      {
        "countryName": "Swahili (Kenya)",
        "localName": "sw_KE",
        "dominantName": "sw_KE"
      },
      {
        "countryName": "Swedish (Finland)",
        "localName": "sv_FI",
        "dominantName": "sv_SE"
      },
      {
        "countryName": "Swedish (Sweden)",
        "localName": "sv_SE",
        "dominantName": "sv_SE"
      },
      {
        "countryName": "Syriac (Syria)",
        "localName": "syr_SY",
        "dominantName": "syr_SY"
      },
      {
        "countryName": "Tamil (India)",
        "localName": "ta_IN",
        "dominantName": "ta_IN"
      },
      {
        "countryName": "Telugu (India)",
        "localName": "te_IN",
        "dominantName": "te_IN"
      },
      {
        "countryName": "Thai (Thailand)",
        "localName": "th_TH",
        "dominantName": "th_TH"
      },
      {
        "countryName": "Tswana (South Africa)",
        "localName": "tn_ZA",
        "dominantName": "tn_ZA"
      },
      {
        "countryName": "Turkish (Turkey)",
        "localName": "tr_TR",
        "dominantName": "tr_TR"
      },
      {
        "countryName": "Ukrainian (Ukraine)",
        "localName": "uk_UA",
        "dominantName": "uk_UA"
      },
      {
        "countryName": "Uzbek (Uzbekistan)",
        "localName": "uz_UZ",
        "dominantName": "uz_UZ"
      },
      {
        "countryName": "Vietnamese (Vietnam)",
        "localName": "vi_VN",
        "dominantName": "vi_VN"
      },
      {
        "countryName": "Welsh (United Kingdom)",
        "localName": "cy_GB",
        "dominantName": "cy_GB"
      },
      {
        "countryName": "Xhosa (South Africa)",
        "localName": "xh_ZA",
        "dominantName": "xh_ZA"
      },
      {
        "countryName": "Zulu (South Africa)",
        "localName": "zu_ZA",
        "dominantName": "zu_ZA"
      }
    ]
""".trimIndent()
